import config from 'config';
import API from 'services/AUTH_API';
import Storage from 'services/Storage';

export default function logout() {
  let data = new FormData();
  data.append('token', Storage.getItem(config.tokenItemName));
  return API.request({
    method: 'POST',
    url: `/oauth/revoke`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: data,
  });
}
